import { client } from '../client';

export interface InsuranceCarrier {
  id: number;
  name: string;
}

const normalizeCarrierName = (name: string): string => name.trim().replace(/\s+/g, ' ');

export const listInsuranceCarriers = async (): Promise<InsuranceCarrier[]> => {
  const { data } = await client.get('/insurance_carriers');

  const uniqueByName = new Map<string, InsuranceCarrier>();

  (Array.isArray(data) ? data : []).forEach((carrier) => {
    const rawName = typeof carrier?.name === 'string' ? carrier.name : '';
    const normalizedName = normalizeCarrierName(rawName);
    const id = Number(carrier.id);
    if (!normalizedName || !Number.isFinite(id)) return;

    const dedupeKey = normalizedName.toLowerCase();
    if (!uniqueByName.has(dedupeKey)) {
      uniqueByName.set(dedupeKey, { id, name: normalizedName });
    }
  });

  return Array.from(uniqueByName.values()).sort((a, b) => a.name.localeCompare(b.name));
};
